document.addEventListener("DOMContentLoaded", () => {
  // Top Header to Main Header
  const topHeader = document.querySelector('#top-header');
  const mainHeader = document.querySelector('#main-header');

  mainHeader.prepend(topHeader);

  // Top Icons Socials
  const etSecondaryMenu = document.querySelector('#et-secondary-menu');
  const textSocial = document.createElement('P');
  textSocial.innerHTML = "<p>Follow Us</p>";
  etSecondaryMenu.prepend(textSocial);

  // Add Social Links
  const socialList = mainHeader.querySelector('.et-social-icons');
  const socialArr = [
    {
      iconClass: 'et-social-youtube',
      name: 'Youtube',
      url: 'https://www.youtube.com/channel/UCqK50xsZBwnm_QT1Q7_wLMg'
    },
    {
      iconClass: 'et-social-podcast',
      name: 'Podcast',
      url: '#'
    }
  ]

  socialArr.map(social => {
    let socialElem = document.createElement('LI');
    socialElem.classList.add('et-social-icon');
    socialElem.classList.add(social.iconClass);
    socialElem.innerHTML = `
      <a href="${social.url}" class="icon">
        <span>${social.name}</span>
      </a>
    `;

    socialList.appendChild(socialElem);
  });

  // Open New Page
  const links = Array.from(etSecondaryMenu.querySelectorAll('a'));
  links.map(link => link.setAttribute('target', '_blank'));


}); 



// WEBPACK FOOTER //
// ./src/js/elements/header.js